import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CircularProgressIndicator } from '..';
import Icon, { SurfaceIcon, TonalIcon } from '../Icon';
import { useTheme } from '@emotion/react';
import {} from 'react';
const BaseIconButtonFactory = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Element) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = useTheme();
    return (_jsx(Element, { as: "button", ...props, css: [
            {
                cursor: 'pointer',
                ':hover': {
                    filter: 'brightness(1.2)',
                },
            },
            props.disabled && {
                opacity: theme.contentAlpha.disabled,
                color: props.disabledContentColor,
                backgroundColor: props.disabledContainerColor,
                cursor: 'not-allowed',
            },
        ], children: props.loading ? _jsx(CircularProgressIndicator, {}) : props.children }));
};
const IconButton = BaseIconButtonFactory(Icon);
export const TonalIconButton = BaseIconButtonFactory(TonalIcon);
export const SurfaceIconButton = BaseIconButtonFactory(SurfaceIcon);
export default IconButton;
//# sourceMappingURL=IconButton.js.map